// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from "flatbuffers";

import {
  DeviceControllerInfoContent,
  unionToDeviceControllerInfoContent,
  unionListToDeviceControllerInfoContent,
} from "./device-controller-info-content";
import {
  ElevatorControllerInfoMessage,
  ElevatorControllerInfoMessageT,
  verifyElevatorControllerInfoMessage,
} from "./elevator-controller-info-message";
import {
  EscalatorControllerInfoMessage,
  EscalatorControllerInfoMessageT,
  verifyEscalatorControllerInfoMessage,
} from "./escalator-controller-info-message";

export class ControllerInfoMessage implements flatbuffers.IUnpackableObject<ControllerInfoMessageT> {
  bb: flatbuffers.ByteBuffer | null = null;
  bb_pos = 0;
  __init(i: number, bb: flatbuffers.ByteBuffer): ControllerInfoMessage {
    this.bb_pos = i;
    this.bb = bb;
    return this;
  }

  static getRootAsControllerInfoMessage(
    bb: flatbuffers.ByteBuffer,
    obj?: ControllerInfoMessage,
  ): ControllerInfoMessage {
    return (obj || new ControllerInfoMessage()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  static getSizePrefixedRootAsControllerInfoMessage(
    bb: flatbuffers.ByteBuffer,
    obj?: ControllerInfoMessage,
  ): ControllerInfoMessage {
    bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
    return (obj || new ControllerInfoMessage()).__init(
      bb.readInt32(bb.position()) + bb.position(),
      bb,
    );
  }

  messageType(): DeviceControllerInfoContent {
    const offset = this.bb!.__offset(this.bb_pos, 4);
    return offset ? this.bb!.readUint8(this.bb_pos + offset) : DeviceControllerInfoContent.NONE;
  }

  message<T extends flatbuffers.Table>(obj: any): any | null {
    const offset = this.bb!.__offset(this.bb_pos, 6);
    return offset ? this.bb!.__union(obj, this.bb_pos + offset) : null;
  }

  static startControllerInfoMessage(builder: flatbuffers.Builder) {
    builder.startObject(2);
  }

  static addMessageType(builder: flatbuffers.Builder, messageType: DeviceControllerInfoContent) {
    builder.addFieldInt8(0, messageType, DeviceControllerInfoContent.NONE);
  }

  static addMessage(builder: flatbuffers.Builder, messageOffset: flatbuffers.Offset) {
    builder.addFieldOffset(1, messageOffset, 0);
  }

  static endControllerInfoMessage(builder: flatbuffers.Builder): flatbuffers.Offset {
    const offset = builder.endObject();
    builder.requiredField(offset, 6); // message
    return offset;
  }

  static createControllerInfoMessage(
    builder: flatbuffers.Builder,
    messageType: DeviceControllerInfoContent,
    messageOffset: flatbuffers.Offset,
  ): flatbuffers.Offset {
    ControllerInfoMessage.startControllerInfoMessage(builder);
    ControllerInfoMessage.addMessageType(builder, messageType);
    ControllerInfoMessage.addMessage(builder, messageOffset);
    return ControllerInfoMessage.endControllerInfoMessage(builder);
  }

  unpack(): ControllerInfoMessageT {
    return new ControllerInfoMessageT(
      this.messageType(),
      (() => {
        const temp = unionToDeviceControllerInfoContent(
          this.messageType(),
          this.message.bind(this),
        );
        if (temp === null) {
          return null;
        }
        return temp.unpack();
      })(),
    );
  }

  unpackTo(_o: ControllerInfoMessageT): void {
    _o.messageType = this.messageType();
    _o.message = (() => {
      const temp = unionToDeviceControllerInfoContent(this.messageType(), this.message.bind(this));
      if (temp === null) {
        return null;
      }
      return temp.unpack();
    })();
  }

  unpackFields(...fields: string[]): ControllerInfoMessageT {
    const t = new ControllerInfoMessageT();
    const fieldSet = new Set(fields);
    if (fieldSet.has("message_type")) {
      t.messageType = this.messageType();
    }
    if (fieldSet.has("message")) {
      t.message = (() => {
        const temp = unionToDeviceControllerInfoContent(
          this.messageType(),
          this.message.bind(this),
        );
        if (temp === null) {
          return null;
        }
        return temp.unpack();
      })();
    }
    return t;
  }
}

export class ControllerInfoMessageT implements flatbuffers.IGeneratedObject {
  constructor(
    public messageType: DeviceControllerInfoContent = DeviceControllerInfoContent.NONE,
    public message: ElevatorControllerInfoMessageT | EscalatorControllerInfoMessageT | null = null,
  ) {}

  pack(builder: flatbuffers.Builder): flatbuffers.Offset {
    if (this.message === null || this.message === undefined) {
      throw new Error('Required field "message" is not set');
    }
    const message = builder.createObjectOffset(this.message);

    return ControllerInfoMessage.createControllerInfoMessage(builder, this.messageType, message);
  }

  clone(): ControllerInfoMessageT {
    const obj = new ControllerInfoMessageT();
    obj.messageType = this.messageType;
    obj.message =
      this.message !== null && typeof (this.message as any).clone === "function"
        ? (this.message as any).clone()
        : this.message;
    return obj;
  }

  equals(other: ControllerInfoMessageT): boolean {
    if (this.messageType !== other.messageType) return false;
    if (this.message !== null && other.message !== null) {
      if (typeof (this.message as any).equals === "function") {
        if (!(this.message as any).equals(other.message)) return false;
      } else if (this.message !== other.message) return false;
    } else if (this.message !== other.message) return false;
    return true;
  }
}

export function verifyControllerInfoMessage(
  verifier: flatbuffers.Verifier,
  tablePos: number,
): void {
  verifier.checkTable(tablePos);
  try {
    verifier.checkScalarField(tablePos, 4, 1);
    verifier.checkUnionConsistency(tablePos, 4, 6, "message");
    {
      const pos = verifier.checkOffsetField(tablePos, 6);
      if (pos !== 0) {
        const uType = verifier.readFieldUint8(tablePos, 4);
        switch (uType) {
          case 1: // ElevatorControllerInfoMessage
            {
              const o = verifier.readInt32(pos);
              verifyElevatorControllerInfoMessage(verifier, pos + o);
            }
            break;
          case 2: // EscalatorControllerInfoMessage
            {
              const o = verifier.readInt32(pos);
              verifyEscalatorControllerInfoMessage(verifier, pos + o);
            }
            break;
        }
      }
    }
    verifier.checkRequiredField(tablePos, 6, "message");
  } finally {
    verifier.popDepth();
  }
}
